import { action, configure, decorate, observable, runInAction } from 'mobx';
import { error, fetchData, RootStore } from './RootStore';

configure({ enforceActions: 'observed' });

export type keywordType = { keywordId: string; keywordName: string; keywordDef: string };
export type keywordsType = {
  [key: string]: keywordType;
};

export class KeywordStore {
  rootStore: RootStore;
  keywords: keywordsType | null;
  error: error;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.keywords = null;
    this.error = null;
  }

  getKeywords = async (keywordsAPI: string) => {
    if (this.keywords) {
      return;
    }

    this.keywords = null;
    this.error = null;

    try {
      const keyword = await fetchData(keywordsAPI);
      runInAction(() => {
        this.error = null;
        this.keywords = keyword;
      });
    } catch (error) {
      runInAction(() => {
        this.keywords = null;
        this.error = { name: error.name, message: error.message };
      });
    }
  };
}

decorate(KeywordStore, {
  getKeywords: action,
  keywords: observable,
});
